export default __webpack_public_path__ + "static/media/unknown.098db060.png";